import { createContext, useContext, useEffect, useState, useCallback } from "react";
import client from "./api";

const AuthContext = createContext({ user: null, loading: true, refresh: () => {}, logout: () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await client.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const id = window.setTimeout(refresh, 0);
    return () => window.clearTimeout(id);
  }, [refresh]);

  const logout = useCallback(async () => {
    try {
      await client.post("/auth/logout");
    } catch (err) {
      console.warn("Logout request failed; clearing local session anyway:", err?.message || err);
    }
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, refresh, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export function startLogin() {
  // Route the browser to our backend's Discord OAuth start endpoint.
  // The backend builds the authorize URL (with state) and 302s to Discord.
  // After Discord redirects to /api/auth/discord/callback, the backend sets
  // the session cookie and bounces the user to /profile on the frontend.
  const backend = process.env.REACT_APP_BACKEND_URL;
  const target = encodeURIComponent("/profile");
  window.location.href = `${backend}/api/auth/discord/start?redirect=${target}`;
}
